import { createClient, SupabaseClient, SupabaseClientOptions } from '@supabase/supabase-js';
import type { Database } from '../../supabase-client/src/database.types';

// Cache clients by URL so master and tenant can coexist without collisions
// in the Supabase JS client's internal auth / realtime state.
const clients = new Map<string, SupabaseClient<Database>>();

export function getSupabaseClient(
  url: string,
  anonKey: string,
  options?: SupabaseClientOptions<'public'>,
): SupabaseClient<Database> {
  const auth = options?.auth as
    | {
        persistSession?: boolean;
        storage?: unknown;
      }
    | undefined;
  const authMode = auth?.persistSession === false
    ? 'no-auth-persistence'
    : auth?.storage
      ? 'custom-auth-storage'
      : 'default-auth';
  const headers = options?.global?.headers;
  const headerMode = headers
    ? JSON.stringify(Object.entries(headers).sort(([a], [b]) => a.localeCompare(b)))
    : 'no-global-headers';
  const key = `${url}::${authMode}::${headerMode}`;
  let instance = clients.get(key);
  if (!instance) {
    instance = createClient<Database>(url, anonKey, options);
    clients.set(key, instance);
  }
  return instance;
}

export type TypedSupabaseClient = SupabaseClient<Database>;
